import { Link } from 'react-router-dom';

const AdminPanel = () => {
    return (
        <div className="w-full md:min-w-[240px] md:w-[240px] bg-white rounded-xl flex flex-row flex-wrap gap-4 md:flex-col py-4 px-3 text-[#225424]">

            {/* Menu */}
            <div className="flex flex-col gap-4 w-full">
                {/* <div className="flex gap-2 items-center py-2 px-4 w-full rounded-xl bg-[#e2eeed] cursor-pointer">
                    <div className="pt-[5px]"><i className="fi fi-sr-list"></i></div>
                    Tutte le attività
                </div> */}
                {/* <div className="flex gap-2 items-center py-2 px-4 w-full rounded-xl h-fit hover:bg-[#e2eeed] cursor-pointer">
                    <div className="pt-[5px]"><i className="fi fi-rr-user"></i></div>
                    Il mio profilo
                </div>
                <div className="flex gap-2 items-center py-2 px-4 w-full rounded-xl h-fit hover:bg-[#e2eeed] cursor-pointer">
                    <div className="pt-[5px]"><i className="fi fi-rr-heart"></i></div>
                    Favoriti
                </div>
                <div className="flex gap-2 items-center py-2 px-4 w-full rounded-xl h-fit hover:bg-[#e2eeed] cursor-pointer">
                    <div className="pt-[5px]"><i className="fi fi-rr-time-past"></i></div>
                    Cronologia
                </div>
                <div className="flex gap-2 items-center py-2 px-4 w-full rounded-xl h-fit hover:bg-[#e2eeed] cursor-pointer">
                    <div className="pt-[5px]"><i className="fi fi-rr-calendar-check"></i></div>
                    Prenotazione
                </div> */}
            </div>

            <Link to="/handle-activities">
                    <div className="flex gap-2">
                        <div><i className="fi fi-br-running"></i></div>
                        <div>Attività</div>
                    </div>
            </Link>
            <Link to="/handle-companies">
            <div className="flex gap-2">
                <div><i className="fi fi-sr-briefcase"></i></div>
                <div>Aziende</div>
            </div>
            </Link>
            <Link to="/handle-shop">
            <div className="flex gap-2">
                <div><i className="fi fi-sr-shop"></i></div>
                <div>Shop</div>
            </div></Link>


        </div>
    )
}

export default AdminPanel;